module.exports = __webpack_public_path__ + "img/all-bg.png.62a88d77.jpg";